// extracted by mini-css-extract-plugin
export default {"wordForm_card":"MakeWords_wordForm_card__GtRAO","wordForm":"MakeWords_wordForm__wfvPt","error":"MakeWords_error__mW+Za"};